import React, { Component } from 'react';
import { withRouter } from 'react-router';
import {
    SkeletonDisplayText,
    SkeletonBodyText,
    SkeletonThumbnail,
    Page,
    Layout,
    Card,
    FormLayout,
    Spinner,
    BlockStack,
    Icon,
    Text,
    FullscreenBar,
    Popover,
    // ButtonGroup,
    // Button,
    Badge,
    InlineGrid,

} from '@shopify/polaris';
import { CaretDownMinor } from '@shopify/polaris-icons';
import './index.css';
import ImageOptimizationSettingsIcon from '../../assets/ImageOptimizationSettingsIcon'
import ImageAltTextSettingsIcon from '../../assets/ImageAltTextSettingsIcon'
import ImageFilenameSettingsIcon from '../../assets/ImageFilenameSettingsIcon'
import Switch from "react-switch";
import { store } from '../../redux/store';


import Language from '../../i18n/Language';
import utils from '../../utils/utils';
import FooterTrustHelp from '../FooterTrustHelp';
const t = Language

class SkeltonLoading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingLength: 3,
            ApploadingLength: 13,
            appHtml: [],

            isShowQuotaPro: true,   // onpage  额度banner状态
            isShowQuotaImage: true, // 图片压缩 额度banner状态
        };
    }

    UNSAFE_componentWillMount() {
        let quotaBannerPro = null;
        let quotaBannerImage = null;
        try {
            quotaBannerPro = sessionStorage.getItem('quotaBannerPro')
        } catch (e) {
            quotaBannerPro = 0;
        }
        try {
            quotaBannerImage = sessionStorage.getItem('quotaBannerPro')
        } catch (e) {
            quotaBannerImage = 0;
        }
        this.setState({
            isShowQuotaPro: Boolean(Number(quotaBannerPro)),
            isShowQuotaImage: Boolean(Number(quotaBannerImage)),
        })

        // if (window.location.pathname === '/dashboard/integration') {
        //     for (let x = 0; x < this.state.ApploadingLength - 1; x++) {
        //         this.state.appHtml.push(<Layout.Section key={x} variant='oneThird'>
        //             <Card>
        //                 <FormLayout>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                 </FormLayout>
        //             </Card>
        //         </Layout.Section>);
        //     }
        //     if (this.state.ApploadingLength % 3 === 2) {
        //         this.state.appHtml.push(<Layout.Section key={'other' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //     }
        //     if (this.state.ApploadingLength % 3 === 1) {
        //         this.state.appHtml.push(<Layout.Section key={'other' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //         this.state.appHtml.push(<Layout.Section key={'othertwo' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //     }
        //     if (this.state.ApploadingLength % 4 === 3) {
        //         this.state.appHtml.push(<Layout.Section key={'other' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //     }
        //     if (this.state.ApploadingLength % 4 === 2) {
        //         this.state.appHtml.push(<Layout.Section key={'other' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //         this.state.appHtml.push(<Layout.Section key={'othertwo' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //     }
        //     if (this.state.ApploadingLength % 4 === 1) {
        //         this.state.appHtml.push(<Layout.Section key={'other' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //         this.state.appHtml.push(<Layout.Section key={'othertwo' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //         this.state.appHtml.push(<Layout.Section key={'otherthree' + (Math.random() * 1000000).toFixed(0)} variant='oneThird'></Layout.Section>)
        //     }
        // }

    }

    render() {
        const shopify = window.shopify; // shopify 内嵌参数

        let contentRes = null; // 骨架屏
        let titleRes = "SEOAnt"; // 页面标题
        let isShowTitle = false; // 是否展示标题 默认true
        let isFullWidth = false; // 是否全屏 默认false
        let isShowFooter = true; // 是否展示footer
        let isFullscreen = ''; // 全屏对象
        let isDiyLayout = false; // 是否自定义布局

        const title = (icon, title, switchText = '', state = false, isShowIcon = true) => {
            return <div className='optimizeImagestTitle'>
                {isShowIcon ? <Icon source={icon} /> : null}
                <span>{title}</span>
                {Boolean(switchText) ? <Switch onChange={() => this.handleSwitchChange(switchText)} checked={state} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" /> : null}
            </div>
        }

        //首页
        const Dashboard = <BlockStack gap={400}>
            <Layout>
                <Layout.Section>
                    <SkeletonBodyText lines={1} />
                </Layout.Section>
                <br />
                <Layout.Section>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>
            <Layout>
                <Layout.Section variant='oneHalf'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneHalf'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </BlockStack>;

        //SEO Checker 检测页面
        const WebsiteCCheck = <div>
            <div className="class-layout-right">
                <Layout>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                </Layout>

            </div>
        </div>;

        //分数检测服务页面
        const SeoExpertServices = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;

        //批量操作页面
        // const ManualBulkEdit = <div className='page-content'>
        //     <Layout>
        //         <Layout.Section>
        //             <SkeletonBodyText lines={2} />
        //         </Layout.Section>
        //     </Layout>
        //     <br />
        //     <Layout>
        //         <Layout.Section variant='oneThird'>
        //             <Card>
        //                 <BlockStack>
        //                     <SkeletonDisplayText size="medium" />
        //                 </BlockStack>
        //                 <br />
        //                 <FormLayout>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                 </FormLayout>
        //             </Card>
        //         </Layout.Section>
        //         <Layout.Section variant='oneThird'>
        //             <Card>
        //                 <BlockStack>
        //                     <SkeletonDisplayText size="medium" />
        //                 </BlockStack>
        //                 <br />
        //                 <FormLayout>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                     <FormLayout.Group>
        //                         <SkeletonBodyText />
        //                     </FormLayout.Group>
        //                 </FormLayout>
        //             </Card>
        //         </Layout.Section>
        //     </Layout>
        // </div>
        const ManualBulkEdit = <div>
            <BlockStack gap={400}>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <SkeletonDisplayText size="medium" />
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
            </BlockStack>
        </div>

        //图片压缩页面
        // const PageSpeed = <div>
        //     <Layout>
        //         <Layout.Section>
        //             {(Boolean(store.getState().public.publicInit.other_options.user_quota.images) && this.state.isShowQuotaImage) && <>
        //                 <Card>
        //                     <SkeletonBodyText />
        //                     <br />
        //                     <SkeletonDisplayText size="medium" />
        //                 </Card>
        //                 <br />
        //             </>}
        //             <Card>
        //                 <SkeletonDisplayText size="medium" />
        //                 <br />
        //                 <SkeletonBodyText lines={2} />
        //             </Card>
        //             <br />
        //             <Card>
        //                 <FormLayout>
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                 </FormLayout>
        //             </Card>
        //             <br />
        //             <Card>
        //                 <FormLayout>
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText lines={1} />
        //                 </FormLayout>
        //             </Card>
        //             <br />
        //             <SkeletonDisplayText size="medium" />
        //             <br />
        //             <Card>
        //                 <FormLayout>
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                 </FormLayout>
        //             </Card>
        //             <div className="normal-spacing"></div>
        //         </Layout.Section>

        //         <Layout.Section variant='oneThird'>
        //             <Card>
        //                 <SkeletonDisplayText size="medium" />
        //                 <br />
        //                 <SkeletonBodyText />
        //             </Card>
        //             <br />
        //             <Card>
        //                 <FormLayout>
        //                     <SkeletonDisplayText size="medium" />
        //                     <br />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                     <SkeletonBodyText />
        //                 </FormLayout>
        //             </Card>
        //         </Layout.Section>
        //     </Layout>
        // </div>;

        // 新图片压缩
        const PageSpeedNew = <div>
            <div className='Image_Opt_Info'>
                <BlockStack gap={400}>
                    <div className='TopDataBlock'>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </Card>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </Card>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </Card>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </Card>
                    </div>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <SkeletonDisplayText size="medium" />
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </div>

        </div>

        //图片压缩页面
        const PageSpeedSetting = <div className="">
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(null, t("Select optimization mode"), '', false, false)}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageOptimizationSettingsIcon, t("Optimize Images"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageAltTextSettingsIcon, t("Image Alt Text"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageFilenameSettingsIcon, t("Image Filename"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </div>;

        //On page 操作页面
        const OnPageSeo = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            {/* <div className='onpage_data_block loading_onpage'>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
            </div> */}
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;
        // onpage 详情页面
        const OnPageSeoDetail = <div>
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </div>

        // 生成博客页面
        const GenerateBlogPage = <div>
            <BlockStack gap={400}>
                <SkeletonBodyText />
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </BlockStack>
        </div>

        //404 broken link 页面
        const BrokenLink = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;

        //HTML Sitemap 页面
        const HtmlSitemap = <Layout>
            <Layout.Section>
                <Card>
                    <SkeletonDisplayText size="medium" />
                    <br />
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </FormLayout>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
            </Layout.Section>
        </Layout>;

        //外链互换页面
        const ExchangeBacklink = <Layout>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <InlineGrid columns={4} gap="400">
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                </InlineGrid>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
        </Layout>;

        // 外链审计页面
        const BacklinkAudit = <BlockStack gap={400}>
            <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
        </BlockStack>

        //AMP 页面
        const SeoAntAmp = <Layout>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <BlockStack gap={400}>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </Layout.Section>
        </Layout>;

        // AMP 设置页面
        // 问题icon
        // const issueIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.486 0 0 4.486 0 10C0 11.728 0.45 13.42 1.304 14.924L0.101 17.965C-0.357 19.174 0.827 20.358 2.036 19.899L5.076 18.695C6.576 19.55 8.273 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM5.293 9.293C5.48 9.105 5.735 9 6 9C6.265 9 6.52 9.105 6.707 9.293C6.895 9.48 7 9.735 7 10C7 10.265 6.895 10.52 6.707 10.707C6.52 10.895 6.265 11 6 11C5.735 11 5.48 10.895 5.293 10.707C5.105 10.52 5 10.265 5 10C5 9.735 5.105 9.48 5.293 9.293ZM9.293 9.293C9.48 9.105 9.735 9 10 9C10.265 9 10.52 9.105 10.707 9.293C10.895 9.48 11 9.735 11 10C11 10.265 10.895 10.52 10.707 10.707C10.519 10.894 10.265 11 10 11C9.735 11 9.48 10.895 9.293 10.707C9.106 10.519 9 10.265 9 10C9 9.735 9.105 9.48 9.293 9.293ZM14 9C13.735 9 13.48 9.105 13.293 9.293C13.105 9.48 13 9.735 13 10C13 10.265 13.105 10.52 13.293 10.707C13.481 10.894 13.735 11 14 11C14.265 11 14.52 10.895 14.707 10.707C14.894 10.519 15 10.265 15 10C15 9.735 14.895 9.48 14.707 9.293C14.52 9.105 14.265 9 14 9Z" fill="#005BD3" />
        // </svg>
        const SeoAntAmpCustome = <div className='amp_custome_view'>
            <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
            </BlockStack>
        </div>

        // Json LD 页面
        const StructuredData = <div className='skelton_jsonid'>
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>

        </div>;

        // 及时索引
        const InstantIndex = <BlockStack gap={400}>
            <SkeletonDisplayText size="medium" />
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // LocalBusiness
        const LocalBusiness = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        //竞品关键词分析页面
        const CompetitorKeywords = <Layout>
            <Layout.Section>
                <Card>
                    <SkeletonBodyText />
                </Card>
            </Layout.Section>
            <Layout.Section>
                <SkeletonDisplayText size="medium" />
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <SkeletonBodyText />
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
        </Layout>

        //竞品关键词分析页面
        const CompetitorKeywordsDetail = null;

        //竞品关键词分析页面
        // const KeywordsLibrary = <Layout>
        //     <Layout.Section>
        //         <SkeletonBodyText lines={2} />
        //     </Layout.Section>
        //     <Layout.Section>
        //         <Card>
        //             <div className="DetailReport_Empty_New_div_margin_600">
        //                 <Spinner size="large" color="teal" />
        //             </div>
        //         </Card>
        //     </Layout.Section>
        // </Layout>;

        // 我的网站关键词
        const MyWebsiteKeywords = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <div className='mywebsite_dataview'>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </div>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词搜索
        const KeywordsSearch = <BlockStack gap={400}>
            <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <SkeletonBodyText lines={1} />
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词竞争监听
        const CompetitiveKeywordMonitoring = <BlockStack gap={400}>
            {/* <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <SkeletonBodyText lines={1} />
            </Card> */}
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词对比
        const KeywordsGap = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词列表
        const KeywordsListPage = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        //google流量分析页面
        const GoogleSearchConsoleV2 = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                </Layout.Section>
                <Layout.Section>
                    <Card>
                        <SkeletonDisplayText size="medium" />
                        <br />
                        <FormLayout>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </FormLayout>
                        <br />
                        <SkeletonDisplayText size="medium" />
                        <br />
                        <FormLayout>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </FormLayout>
                    </Card>
                </Layout.Section>
            </Layout>
        </div>

        // 旧版价格页面
        const OldPricing = <Layout>
            <Layout.Section>
                <SkeletonBodyText lines={2} />
            </Layout.Section>
            <Layout.Section>
                <div className='pricingLoading'>
                    <div className="pricingContent">
                        <div className="Polaris-Layout">
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard" >
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout.Section>
        </Layout>

        // 新版价格页面
        const Pricing = <div className='pricing_loading_page'>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                </Layout.Section>
            </Layout>
            <div className='halfspace'></div>
            <Layout>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>

            </Layout>
        </div>

        //APP 集合页面
        const FunctionIntegration = <div>
            <div className="Service_Layout_Card" style={{ marginTop: "0" }}>
                <Card>
                    <SkeletonDisplayText size="small" />
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Card>
            </div>
            <div className="Service_Layout_Card" style={{ marginTop: "2rem" }}>
                <Card>
                    <SkeletonDisplayText size="small" />
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Card>
            </div>
        </div>

        //问答页面
        const Feedback = <Card>
            <div className="DetailReport_Empty_New_div_margin_800">
                <Spinner size="large" color="teal" />
            </div>
        </Card>
        // <Layout>
        //     <Layout.Section>
        //         <Layout>
        //             <Layout.Section variant='oneThird'>
        //                 <Card>
        //                     <BlockStack gap={400}>
        //                         <Text variant="headingMd" as="h2">In development</Text>
        //                         <SkeletonBodyText />
        //                         <SkeletonBodyText lines={1} />
        //                     </BlockStack>
        //                 </Card>
        //             </Layout.Section>
        //             <Layout.Section variant='oneThird'>
        //                 <Card>
        //                     <BlockStack gap={400}>
        //                         <Text variant="headingMd" as="h2">New functions</Text>
        //                         <SkeletonBodyText />
        //                         <SkeletonBodyText lines={1} />
        //                     </BlockStack>
        //                 </Card>
        //             </Layout.Section>
        //         </Layout>
        //     </Layout.Section>
        //     <Layout.Section>
        //         <Layout>
        //             <Layout.Section variant='oneHalf'>

        //             </Layout.Section>
        //         </Layout>
        //     </Layout.Section>
        // </Layout>;

        // 指导手册页面
        const InstuctionManual = <div>
            <Card>
                <FormLayout>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </FormLayout>
            </Card>
        </div>

        //活动页面
        const AppActivity = <div className='Polaris-Layout__Section' style={{ maxWidth: '100%', marginLeft: '0' }}>
            <div>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                {/* <div className="halfspace"></div>
                <Card>
                    <FormLayout>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    </FormLayout>
                </Card> */}
                <div className="halfspace"></div>
                <div className="DashboardModuleInfoV2">
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                </div>
            </div>
        </div>

        //推荐应用页面
        const Integration = <div className='integration_page_loading'>
            <BlockStack gap={400}>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                    </BlockStack>
                </Card>
            </BlockStack>
        </div>

        // instant page
        const InstantPage = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                    <div className='halfspace'></div>
                    <Card>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText lines={2} />
                    </Card>
                    <div className='halfspace'></div>
                    <Card>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText lines={2} />
                    </Card>
                </Layout.Section>
            </Layout>
        </div>

        // Site Verifications
        const SiteVerifications = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                    <div className='verify_list'>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                        <Card>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText />
                            <div className='halfspace'></div>
                            <SkeletonBodyText lines={2} />
                        </Card>
                    </div>
                </Layout.Section>
            </Layout>
        </div>

        // 设置页面
        const settingsPage = <div className='set_Select'>
            <div className='left_choice'>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText lines={2} />
                        <SkeletonBodyText lines={2} />
                        <SkeletonBodyText lines={2} />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </div>
            <div className='right_content'>
                <BlockStack gap={400}>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </div>
        </div>

        // 节省表格页面
        const recentImprove = <div>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </div>

        // 图片alt
        const imageAltText = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText lines={1} />
                    <SkeletonBodyText lines={1} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <SkeletonDisplayText />
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>


        const pathName = window.location.pathname; // 路由
        switch (pathName) {
            case "/dashboard":
                //首页
                isShowTitle = true;
                contentRes = Dashboard;
                titleRes = "SEOAnt - Dashboard";
                break;
            case "/website-check":
                //SEO Checker 检测页面
                isShowTitle = true;
                contentRes = WebsiteCCheck;
                titleRes = "SEOAnt - SEO Checker";
                break;
            case "/speedOpt":
            case "/speedOpt/site-speedup":
                //分数检测服务页面
                contentRes = SeoExpertServices;
                titleRes = "SEOAnt - Google PageSpeed Checker";
                break;
            case "/searchAppearance":
            case "/searchAppearance/bulk-edit/manual-bulk-edit":
                //批量操作页面
                contentRes = ManualBulkEdit;
                titleRes = "SEOAnt - Bulk Edit";
                break;
            case "/speedOpt/PageSpeed":
                //图片压缩页面
                // contentRes = PageSpeed;
                contentRes = PageSpeedNew;
                titleRes = "SEOAnt - Image Optimization";
                break;
            case "/admin/PageSpeed/setting":
                //图片压缩页面
                contentRes = PageSpeedSetting;
                titleRes = "SEOAnt - Image Optimization";
                break;
            case "/on-page-seo":
                //On page 操作页面
                isShowTitle = true;
                contentRes = OnPageSeo;
                titleRes = "SEOAnt - On-Page SEO Scan";
                // isFullWidth = true;
                break;
            case "/on-page-seo/detail":
                //On page 操作详情页面
                contentRes = OnPageSeoDetail;
                titleRes = "SEOAnt - Detail";
                isFullWidth = true;
                isFullscreen = 'onpage';
                isDiyLayout = true;
                break;
            case "/on-page-seo/generate-blog":
                //On page 操作详情页面
                contentRes = GenerateBlogPage;
                titleRes = "SEOAnt - Generate Blog";
                isFullscreen = 'onpage-blog';
                break;
            case "/backlinks":
            case "/backlinks/broken-link/view-errors":
                //404 broken link 页面
                // contentRes = ViewErrors;
                contentRes = BrokenLink;
                titleRes = "SEOAnt - Broken Links";
                break;
            case "/backlinks/broken-link/manage-redirects":
                //404 broken link 页面
                // contentRes = ManageRedirects;
                contentRes = BrokenLink;
                titleRes = "SEOAnt - Broken Links";
                break;
            case "/backlinks/broken-link/ignore-page":
                //404 broken link 页面
                // contentRes = IgnorePage;
                contentRes = BrokenLink;
                titleRes = "SEOAnt - Broken Links";
                break;
            case "/backlinks/html-sitemap":
                //HTML Sitemap 页面
                contentRes = HtmlSitemap;
                titleRes = "SEOAnt - HTML Sitemap";
                break;
            case "/backlinks/exchange-backlink":
                //外链互换页面
                contentRes = ExchangeBacklink;
                titleRes = "SEOAnt - Exchange Backlink";
                break;
            case "/backlinks/backlink-audit":
                //外链审计页面
                contentRes = BacklinkAudit;
                titleRes = "SEOAnt - Backlink Audit";
                break;
            case "/speedOpt/seo-ant-amp":
                //AMP 页面
                contentRes = SeoAntAmp;
                titleRes = "SEOAnt - AMP";
                break;
            case "/speedOpt/seo-ant-amp/custome":
                //AMP 设置页面
                contentRes = SeoAntAmpCustome;
                isFullscreen = 'amp_custome';
                isDiyLayout = true;
                titleRes = "SEOAnt - AMP Settings";
                break;
            case "/searchAppearance/structured-data":
                // Json LD 页面
                contentRes = StructuredData;
                titleRes = "SEOAnt - Snippets - JSON-LD";
                break;
            case "/searchAppearance/instant-index":
                // Instant index 页面
                contentRes = InstantIndex;
                titleRes = "SEOAnt - Instant Index";
                break;
            case "/searchAppearance/local-business":
                // Local Business 页面
                contentRes = LocalBusiness;
                titleRes = "SEOAnt - Local Business";
                break;
            case "/keywordRearch":
            case "/keywordRearch/keywords-research":
                // case "/admin/Competitor-Keywords":
                //竞品关键词分析页面
                contentRes = CompetitorKeywords;
                titleRes = "SEOAnt - Competitor Keywords Research";
                isShowFooter = false;
                break;
            case "/keywordRearch/keywords-research/Competitor-keywords-detail":
                //竞品关键词分析页面
                contentRes = CompetitorKeywordsDetail;
                titleRes = "SEOAnt - Competitor Keywords Research";
                break;
            case "/keywordRearch/my-website-keywords":
                // 我的网站关键词
                contentRes = MyWebsiteKeywords;
                titleRes = "SEOAnt - My website keywords";
                // isFullWidth = true;
                break;
            case "/keywordRearch/keywords-search":
                // 关键词搜索
                contentRes = KeywordsSearch;
                titleRes = "SEOAnt - Keyword Search";
                break;
            case "/keywordRearch/keywords-monitor":
                // 竞争关键词监听
                contentRes = CompetitiveKeywordMonitoring;
                titleRes = "SEOAnt - Competitive keyword monitoring";
                // isFullWidth = true;
                break;
            case "/keywordRearch/keywords-gap":
                // 关键词对比
                contentRes = KeywordsGap;
                titleRes = "SEOAnt - Keyword Gap";
                // isFullWidth = true;
                break;
            case "/keywordRearch/keywords-list":
                // 关键词列表
                contentRes = KeywordsListPage;
                titleRes = "SEOAnt - Keywords List";
                break;
            // case "/keywordRearch/keywords-research":
            //     //竞品关键词分析页面
            //     contentRes = KeywordsLibrary;
            //     titleRes = "SEOAnt - Keywords Library";
            //     break;
            case "/searchAppearance/GoogleSearchConsoleV2":
                //google流量分析页面
                contentRes = GoogleSearchConsoleV2;
                titleRes = "SEOAnt - Google Analytics";
                break;
            case "/oldversion/pricing":
                // 旧价格页面
                contentRes = OldPricing;
                titleRes = "SEOAnt - Pricing";
                break;
            case "/plan":
                // 新价格页面
                isShowTitle = Boolean(store.getState().public.isShowTopMenu) || 1;
                contentRes = Pricing;
                titleRes = "SEOAnt - Pricing";
                break;
            case "/admin/function-integration":
                //APP 集合页面
                contentRes = FunctionIntegration
                titleRes = "SEOAnt - Reviews Integrations";
                break;
            case "/dashboard/Feedback":
                //问答页面
                contentRes = Feedback;
                titleRes = "SEOAnt - Feedback";
                isShowTitle = true;
                break;
            case "/admin/instuction-manual/index":
                //新手指引页面
                contentRes = InstuctionManual;
                titleRes = "SEOAnt - Guide";
                break;
            case "/admin/app-activity/index":
                //活动页面
                contentRes = AppActivity;
                titleRes = "SEOAnt - App Activity";
                break;
            case "/dashboard/integration":
                //推荐应用页面
                contentRes = Integration;
                titleRes = "SEOAnt - Integration";
                break;
            case "/speedOpt/instant-page":
                //Instant Page
                contentRes = InstantPage;
                titleRes = "SEOAnt - Instant Page";
                break;
            case "/admin/site-verifications/index":
                //Site Verifications
                contentRes = SiteVerifications;
                titleRes = "SEOAnt - Site Verifications";
                break;
            case "/settings":
                isShowTitle = Boolean(store.getState().public.isShowTopMenu) || 1;
                contentRes = settingsPage;
                titleRes = "SEOAnt - Settings";
                break;
            case "/dashboard/recent-improvements":
                contentRes = recentImprove;
                titleRes = "SEOAnt - Recent Improvements";
                isShowTitle = true;
                break;
            case "/searchAppearance/image-alt-text":
                contentRes = imageAltText;
                titleRes = "SEOAnt - Image alt text";
            default:
                break;
        }

        // 底部
        const footerHelp = <FooterTrustHelp />

        const pageMain = isDiyLayout ? <div className='Layout_Box'>
            <div className='lb_left_list'>
                <div className='lb_card' style={{ padding: '1rem' }}>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </div>
            </div>
            <div className='lb_right_main'>
                <Page
                    fullWidth={isFullWidth}
                >
                    <title>{titleRes}</title>
                    {
                        isShowTitle && <>
                            <SkeletonDisplayText />
                            <br />
                        </>
                    }
                    {contentRes}
                    {isShowFooter && footerHelp}
                </Page>
            </div>
        </div> : <Page
            fullWidth={isFullWidth}
        >
            <title>{titleRes}</title>
            {
                isShowTitle && <>
                    <SkeletonDisplayText />
                    <br />
                </>
            }
            {contentRes}
            {isShowFooter && footerHelp}
        </Page>


        return (
            <div id='SkeltonLoadingBox'>
                <div className={`top_bar_fullscreen ${shopify ? 'embeddedFull' : ''}`}>
                    {
                        isFullscreen.indexOf('onpage') > -1 && <FullscreenBar onAction={() => {
                            utils.routeJump(this, '/on-page-seo')
                        }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingLeft: '1rem',
                                    paddingRight: '1rem',
                                }}
                            >
                                {/* <div className='fullscreen_top'>
                                    <img src='/newlogo.png' alt='newlogo' />
                                    <Text variant="headingMd" as="p">{t("SEOAnt")}</Text>
                                </div> */}
                                {
                                    isFullscreen.indexOf('blog') > -1 ? <div>
                                        {t("Generate Blog post with SEOAnt AI")}
                                    </div> :
                                        <div className='flex_layout'>
                                            <Popover
                                                active={false}
                                                activator={<div className='flex_layout select_type'>
                                                    {t("Loading..")}<Icon source={CaretDownMinor} tone='base' />
                                                </div>}
                                                autofocusTarget="first-node"
                                            >
                                            </Popover>
                                            <span>&nbsp;|&nbsp;</span>
                                            <Popover
                                                active={false}
                                                activator={<div className='flex_layout select_type'>
                                                    {t("Loading..")}<Icon source={CaretDownMinor} tone='base' />
                                                </div>}
                                                autofocusTarget="sec-node"
                                            >
                                            </Popover>
                                        </div>
                                }
                                <div className='full_btn_group'>
                                    <div className='SEO_Score_face'><SkeletonBodyText lines={2} /></div>
                                    {/* <Button disabled={true}>{t("Preview")}</Button> */}
                                    {/* <ButtonGroup>
                                        <Button disabled={true}>{t("Discard")}</Button>
                                        <Button
                                            variant="primary"
                                            disabled={true}
                                        >
                                            {t("Save")}
                                        </Button>
                                    </ButtonGroup> */}
                                </div>
                            </div>
                        </FullscreenBar>
                    }
                    {
                        isFullscreen === 'amp_custome' && <FullscreenBar onAction={() => {
                            utils.routeJump(this, '/speedOpt/seo-ant-amp')
                        }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingLeft: window.innerWidth < 450 ? '0.3rem' : '1rem',
                                    paddingRight: window.innerWidth < 450 ? '0.3rem' : '1rem',
                                }}
                            >
                                <div className='fullscreen_top_amp'>
                                    {window.innerWidth < 450 ? null : <Text variant="headingMd" as="p">{t("Homepage")}</Text>}
                                    <Badge>{t("Unpublished")}</Badge>
                                    <div className="custome_switch">
                                        <Switch disabled={true} onChange={() => { }} checked={false} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                        {true && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                    </div>
                                </div>
                                {/* <div className='full_btn_group flex_layout'>
                                    <div className='need_help_amp'>
                                        {issueIcon} <span>{t("Need help")}?</span>
                                    </div>
                                    <Button variant='primary' disabled={true}>{t("Preview")}</Button>
                                </div> */}
                            </div>
                        </FullscreenBar>
                    }
                </div>
                {pageMain}
            </div>
        );
    }
}

export default withRouter(SkeltonLoading);